import * as APP_CONSTANTS from '../shared/Constants';
import { TripleDES, enc, mode, SHA256 } from 'crypto-js';
import { Buffer } from 'buffer';
import { THEME_ID } from '../shared/styles';

export const encryptDataWithTripleDES = theInput => {
	//Do something with the input
	let _strEncryptedParams = TripleDES.encrypt(
		theInput,
		enc.Utf8.parse(APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_KEY),
		{
			iv: enc.Utf8.parse(APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_VECTOR),
			mode: mode.CBC,
		},
	).toString();

	return _strEncryptedParams;
};

export const hashFileName = fileName => {
	return encodeURIComponent(fileName);

	// const encoder = new TextEncoder();
	//   return Array.from(encoder.encode(fileName))
	//       .map(i => i
	//           .toString(2)
	//           .padStart(8, '0'))
	//       .join(' ')

	const utfEncode = encoder.encode(fileName);
	const utf8Encoded = enc.Utf8.parse(fileName);
	console.log('ASSA', utf8Encoded);
	console.log('UTFEB', utfEncode, utfEncode?.Uint8Array);
	// const base64Encoded = enc.Base64.stringify(utfEncode);
	// return base64Encoded

	// // Generate a SHA256 hash of the file name
	// const hash = SHA256(fileName).toString();
	// // Convert the hash to UTF-8 encoding
	// const utf8Encoded = enc.Utf8.parse(fileName);
	// // Convert the UTF-8 encoded hash to a Base64 string
	// const base64Encoded = enc.Base64.stringify(utf8Encoded);
	// return utf8Encoded;
};

export const encodeDataWithBase64 = theInput => {
	//Do something with the input

	const _objEncodedWord = enc.Utf8.parse(theInput.toString());
	const _strEncryptedParams = enc.Base64.stringify(_objEncodedWord);

	return _strEncryptedParams;
};

export const handleEncryption = input => {
	let ciphertext = TripleDES.encrypt(
		JSON.stringify(input),
		APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_KEY,
	).toString();

	const encodedString = Buffer.from(ciphertext).toString('base64');

	return encodedString;
};

const handleDecryption = encodedString => {
	if (!encodedString) return encodedString;

	const decodeBase64 = Buffer.from(encodedString, 'base64').toString('ascii');
	const bytes = TripleDES.decrypt(decodeBase64, APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_KEY);
	return JSON.parse(bytes.toString(enc.Utf8));
};

export const getUsernameAndTenantId = (_strTenantID, _strUsername) => {
	//Do something with the input

	let _strUsernameForEncryption = '';
	_strUsernameForEncryption =
		_strTenantID == '' || _strTenantID == undefined ? _strUsername : _strTenantID + '||' + _strUsername;

	return _strUsernameForEncryption;
};

export const getEnvironmentNameFromWSURL = (_strServerURL = '') => {
	//Do something with the input

	const _strHttpsTag = '://';
	const _strMSPluginTag = 'MSPluginWebService';
	let _strEnvironmentName = _strServerURL;

	let _nStarIndex = -1;
	let _nEndIndex = -1;

	_nStarIndex = _strServerURL.toString().includes(_strHttpsTag) ? _strServerURL.indexOf(_strHttpsTag) : 0;
	_nEndIndex = _strServerURL.toString().includes(_strMSPluginTag)
		? _strServerURL.indexOf(_strMSPluginTag)
		: _strServerURL.length - 1;

	_strEnvironmentName =
		_nStarIndex > -1 && _nEndIndex > -1 && _nStarIndex != _nEndIndex
			? _strServerURL.toString().substr(_nStarIndex, _nEndIndex - _nStarIndex)
			: _strServerURL;

	return _strEnvironmentName;
};

export const createAPIURLWithParams = (_strBaseURL, _strAPIName, objMap) => {
	let _strAPIURL = '';
	let _strInputParams = '';
	try {
		//  Create Query String Params
		objMap.forEach((value, key, map) => {
			_strInputParams += key + '=' + value + '&';
		});

		//  Encrypt Query String Params
		_strInputParams = encryptDataWithTripleDES(
			_strInputParams,
			APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_KEY,
			APP_CONSTANTS.CMIC_KEYS.SERVER_SETTINGS_ENCRYPTION_VECTOR,
		);

		//  Encode Query String Params
		_strInputParams = encodeDataWithBase64(_strInputParams);

		// _strAPIURL += _strBaseURL + _strAPIName + "?param=" + _strInputParams;
		_strAPIURL += '/cmicdevv12/MSPluginWebService/resources/MSPluginWS/';

		_strAPIURL += _strAPIName + '?param=' + _strInputParams;

		return _strAPIURL;
	} catch (error) {
		console.log('ERROR', error);
		return '';
	}
};

export const isJSONObjectEmpty = obj => {
	return JSON.stringify(obj) === '{}';
};

export const formatBytes = (bytes, decimals = 0) => {
	if (bytes === 0) {
		return '0 Bytes';
	}
	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const checkParentAddittion = nodeType => {
	switch (nodeType) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_REVISION:
			return true;

		default:
			return false;
	}
};

export const handleAddOnType = nodeType => {
	switch (nodeType) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENTS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_PCI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_RFI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
			return true;

		default:
			return false;
	}
};

export const handleBreadCrumbsAddittion = (id, label, breadcrumbs) => {
	const brdCrmbs = [...breadcrumbs];
	const breadIndex = brdCrmbs.findIndex(e => e.id === id);

	if (breadIndex === -1) {
		brdCrmbs.push({
			id,
			label,
		});
	} else {
		brdCrmbs[breadIndex] = {
			id,
			label,
		};
	}

	return brdCrmbs;
};

export const handleProjectDataFiller = (projectInfo, isDefaultProj) => {
	try {
		// Fetch project list
		const encodedProjInfo = localStorage.getItem(APP_CONSTANTS.CMIC_KEYS.PROJECT_LIST_ENCRYPTION_KEY);
		const projList = handleDecryption(encodedProjInfo) || [];

		const listLength = projList.length;
		// If there's no info about project return list
		if (!projectInfo) {
			return projList;
		}

		// Check if there's default proj
		// If there's default project and we don't have any project in cache then we'll set default project as selected project
		if (isDefaultProj && !listLength) {
			projList.push(projectInfo);
		}
		// If it's not default project and we got some project Info then
		if (!isDefaultProj && projectInfo) {
			// We'll check if that project is already present in our list

			const isProjPresent = projList.findIndex(e => e.nodeId === projectInfo.nodeId);

			if (isProjPresent === -1) {
				// If length of the list is equal to limit then we'll remove last used project
				if (listLength === APP_CONSTANTS.PROJ_LIST_LIMIT) {
					projList.pop();
				}
				// Then, we'll add selected project at the top
				projList.unshift(projectInfo);
			} else {
				//If index is at last we'll remove it and add latest info at start
				if (isProjPresent === listLength - 1) {
					projList.pop();
					projList.unshift(projectInfo);
				} else if (isProjPresent === 0) {
					// If project is at start we'll update info
					projList[isProjPresent] = projectInfo;
				} else {
					// If it's in B/W somewhere then we'll remove it from that index and push it at top
					projList.splice(isProjPresent, 1); // First param is for index and second is to remove count of items from that index
					projList.unshift(projectInfo);
				}
			}
		}

		const encryptProjList = handleEncryption(projList);
		const encryptSelectedProj = handleEncryption(projList[0]);
		localStorage.setItem(APP_CONSTANTS.CMIC_KEYS.PROJECT_LIST_ENCRYPTION_KEY, JSON.stringify(encryptProjList));
		localStorage.setItem(APP_CONSTANTS.CMIC_KEYS.SELCTED_PROJ_ENCRYPTION_KEY, JSON.stringify(encryptSelectedProj));
		return projList;

		// If there's not default project and user selected any project

		// Check if it's in the list
	} catch (error) {
		console.log('handleProjectDataFiller() ERROR', error);
		return [];
	}
};

export const createOpenURLImaging = (activeNode, serverURL, data) => {
	if (!serverURL) return '';
	const SERVER_NAME = `ImgMgr/imgMgrStart.do`;
	if (activeNode === APP_CONSTANTS.CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION) {
		return data?.ImgdVUuid ? `${serverURL}/${SERVER_NAME}?docUuid=${data?.ImgdVUuid}` : '';
	} else {
		return '';
	}
};

export const createOpenURL = (activeNode, serverURL, projUuid, data) => {
	if (!serverURL || !projUuid) return '';

	const SERVER_NAME = `construct-pm/projects`;
	switch (activeNode) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_RFI:
			return data?.VUuid ? `${serverURL}/${SERVER_NAME}/${projUuid}/rfis/${data.VUuid}` : '';

		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
			return data?.VUuid ? `${serverURL}/${SERVER_NAME}/${projUuid}/issues/${data.VUuid}` : '';

		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
			return data?.VUuid ? `${serverURL}/${SERVER_NAME}/${projUuid}/journals/${data.VUuid}` : '';

		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_PCI:
			return data?.VUuid ? `${serverURL}/${SERVER_NAME}/${projUuid}/pcis/${data.VUuid}` : '';

		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
			return data?.PmsmSbmtOraseq
				? `${serverURL}/SdMenu/?contentUrl=../PmSubmittal/?subOraseq=${data.PmsmSbmtOraseq}`
				: '';

		default:
			return '';
	}
};

export const isBGClrDark = () => {
	try {
		let theme;
		let officeTheme = Office?.context?.officeTheme;
		if (officeTheme?.themeId) {
			theme = officeTheme?.themeId ? officeTheme?.themeId : THEME_ID.WHITE;
		} else {
			if (officeTheme?.bodyBackgroundColor === '#212121') {
				theme = THEME_ID.BLACK;
			} else {
				theme = THEME_ID.WHITE;
			}
		}
		switch (theme) {
			case THEME_ID.WHITE:
			case THEME_ID.COLORFUL:
				return false;
			default:
				return true;
		}
	} catch (error) {
		console.log('isBGClrDark() ERROR', error);
		return true;
	}
};

export const handleSearchBarVisibility = node => {
	switch (node) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL:
			return true;

		default:
			return false;
	}
};

export const splitLastOccurrence = str => {
	if (!str || !str.includes('.')) {
		return { attachmentName: str, extension: '' };
	}

	let splitData = str.split('.');

	let substring = splitData[splitData.length - 1];

	const lastIndex = str.lastIndexOf(substring);

	const attachmentName = str.slice(0, lastIndex - 1);

	const extension = str.slice(lastIndex - 1).toLowerCase();

	return { attachmentName, extension };
};

export const fetchFileType = str => {
	const { extension } = splitLastOccurrence(str);
	if (
		extension.includes('.png') ||
		extension.includes('.jpeg') ||
		extension.includes('.jpg') ||
		extension.includes('.png') ||
		extension.includes('.bmp') ||
		extension.includes('.tiff')
		//  extension === 'image'
	) {
		return APP_CONSTANTS.FILE_TYPE.Image;
	} else if (
		extension.includes('.mp4') ||
		extension.includes('.mov') ||
		extension.includes('.wmv') ||
		extension.includes('.avi') ||
		extension.includes('.avchd') ||
		extension.includes('.flv') ||
		extension.includes('.f4v') ||
		extension.includes('.swf') ||
		extension.includes('.mkv') ||
		extension.includes('.webm')
	) {
		return APP_CONSTANTS.FILE_TYPE.Video;
	} else if (extension.includes('.pdf')) {
		return APP_CONSTANTS.FILE_TYPE.Pdf;
	} else if (extension.includes('.txt')) {
		return APP_CONSTANTS.FILE_TYPE.Text;
	} else if (extension.includes('.eml') || extension.includes('.msg')) {
		return APP_CONSTANTS.FILE_TYPE.Email;
	} else if (extension.includes('.json')) {
		return APP_CONSTANTS.FILE_TYPE.JSON;
	} else if (extension.includes('.zip')) {
		return APP_CONSTANTS.FILE_TYPE.Zip;
	} else if (extension.includes('.xls') || extension.includes('.xlsx') || extension.includes('.csv')) {
		return APP_CONSTANTS.FILE_TYPE.Excel;
	} else if (extension.includes('.mp3')) {
		return APP_CONSTANTS.FILE_TYPE.Audio;
	} else if (extension.includes('.doc') || extension.includes('.docx')) {
		return APP_CONSTANTS.FILE_TYPE.Word;
	} else if (extension.includes('.xml') || extension.includes('.docx')) {
		return APP_CONSTANTS.FILE_TYPE.Xml;
	} else {
		APP_CONSTANTS.FILE_TYPE.Other;
	}
};

export const filterEmptyFields = obj => {
	for (let k in obj) if (!obj[k] || obj[k] == '') delete obj[k];

	return obj;
};

export const handlePageSize = nodeType => {
	switch (nodeType) {
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENTS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_PCI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_RFI:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
		case APP_CONSTANTS.CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
			return APP_CONSTANTS.DOC_PAGE_LIMIT;

		default:
			return APP_CONSTANTS.PAGE_LIMIT;
	}
};

export const checkNoneInlineAttachmentCount = attachments => {
	if (attachments?.length) return true;
	else return false;
};
